import { Award } from "lucide-react";
import { WHATSAPP_URL } from "@/data/menu";

const PHOTOS = [
  { src: "/assets/baianeira/nigiri-pistacchio.jpg", alt: "Nigiri al salmone con crema di pistacchio" },
  { src: "/assets/baianeira/tartare-salmone.jpg", alt: "Tartare di salmone e avocado" },
  { src: "/assets/baianeira/nigiri-trio.jpg", alt: "Trio di nigiri: salmone, ricciola e tonno" },
  { src: "/assets/baianeira/tiki-sushi.jpg", alt: "Cocktail tiki e tagliere di sushi" },
  { src: "/assets/baianeira/tagliere-nigiri.jpg", alt: "Tagliere di nigiri al salmone e tonno" },
  { src: "/assets/baianeira/tagliere-fiori.jpg", alt: "Tagliere di sushi fusion con fiori commestibili" },
];

export const PhotoStrip = () => (
  <section aria-label="I nostri piatti" className="overflow-hidden bg-[#0A1F14]/40 pt-20 pb-6 md:pt-24 md:pb-8">
    <p
      data-testid="photostrip-claim"
      className="px-6 text-center font-display text-base tracking-[0.18em] text-[#D4AF37] md:text-xl"
    >
      TRA I PRIMI SUSHI A ROMA
    </p>
    <div className="mt-3 flex justify-center">
      <span
        data-testid="photostrip-top-quality"
        className="inline-flex items-center gap-2 border border-[#D4AF37] bg-[#D4AF37]/10 px-4 py-2 text-[10px] font-bold tracking-[0.25em] text-[#D4AF37] md:text-xs"
      >
        <Award size={14} /> TOP QUALITY
      </span>
    </div>

    <div className="group relative mt-5 overflow-hidden md:mt-6">
      <div className="animate-marquee-slow group-hover:[animation-play-state:paused] flex w-max">
        {[0, 1].map((copy) => (
          <div key={copy} aria-hidden={copy === 1} className="flex">
            {PHOTOS.map((p, i) => (
              <a
                key={`${copy}-${p.src}`}
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`Prenota su WhatsApp: ${p.alt}`}
                data-testid={copy === 0 ? `photostrip-item-${i}` : undefined}
                className="mx-2 block overflow-hidden border border-[#D4AF37]/25 transition-colors duration-300 hover:border-[#D4AF37] md:mx-3"
              >
                <img
                  src={p.src}
                  alt={p.alt}
                  loading="lazy"
                  className="h-32 w-28 object-cover transition-transform duration-500 hover:scale-105 md:h-44 md:w-32"
                />
              </a>
            ))}
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default PhotoStrip;
